let jquery = $;

const FormModal = function(element, options) {
    let the = this;
    const _handlers = function() {
        const $modal = $('#editModal').modal({
            blurring: false,
            closable: false,
            onApprove : function() {
                const $form = $modal.find('form');
                let formData = new FormData($form[0]);
                let error = false;
                $modal.dimmer('show');
                $.ajax({
                    url: $form.attr('action'),
                    data: formData,
                    method: 'POST',
                    async: false,
                    processData: false,
                    contentType: false,
                    success: function(response) {
                        $modal.html(response);
                        afterAjaxLoaded($modal);
                        $modal.dimmer('hide');
                    },
                    error: function(response) {
                        error = true;
                        $modal.html(response.responseText);
                        afterAjaxLoaded($modal);
                        $modal.dimmer('hide');
                    }
                });

                return false;
            }
        });

        const afterAjaxLoaded = function($modal) {
            $modal.find('.message .close')
              .on('click', function() {
                $(this)
                  .closest('.message')
                  .transition('fade')
                ;
              })
            ;
            const $message = $modal.find('.message .close').closest('.message')
            setTimeout(() => {
              $message.transition('fade')
            }, 3000)
            const $button = $modal.find('.modal-button-action-success')


            if ($button.length > 0) {
              if ($button.eq(0).data('toastr-success-message')) {
                toastr.success($button.eq(0).data('toastr-success-message'));
              }

              setTimeout(() => {
                const $span = $button.find('span')
                $button.removeClass('icon')
                $button.find('.icon').hide()
                $span.html($span.data('text'))
                $span.css('display', 'inline')
              }, 2000)
            }

            $modal.handleInitOptionValueSortableList();
            $modal.handleInitOptionValueTaxonTreeExpand();

            $modal.find('.app-product-taxonomy-tree').each(function() {
              $(this).choiceTree('optionValueTaxon', true, 9);
            });

            $modal.find('.sylius-autocomplete').autoComplete();

            $modal.find('.product-select.ui.fluid.multiple.search.selection.dropdown').productAutoComplete();
            $modal.find('div#variantAttributeChoice > .ui.dropdown.search').productVariantAttributes();

            $modal.find('[data-form-type="collection"]').CollectionForm();
            $modal.find('.sylius-tabular-form .menu .item').tab({
                onLoad: function(tab) {
                    the.lastTab = tab;
                },
            });

            $modal.previewUploadedImage('.images-gallery');

            $modal.find('.sylius-tabular-form').addTabErrors();
            $modal.find('.sylius-tabular-form').addDictionaryTabErrors();

            $modal.find('.ui.accordion').accordion();

            if (typeof the.lastTab !== "undefined") {
                $modal.find('.sylius-tabular-form .menu .item').tab('change tab', the.lastTab);
            }

            $modal.handleOpenProductImagesModal($modal);
            $modal.handleSelectProductImageInFileManager();

            jquery(document).on('collection-form-add', function () {
              $modal.previewUploadedImage('.images-gallery');
              $modal.handleOpenProductImagesModal($modal);
            });

            $modal.handleSetDefaultInput('#app_product_composition_values');

            $modal.handleOpenProductCompositionImagesModal($modal);
            $modal.handleSelectProductCompositionImageInFileManager();
            $modal.handleRemoveProductCompositionImage();

            $modal.handleOpenDictionaryImageFileManagerModal($modal)
            $modal.handleSelectDictionaryImageInFileManager()
            $modal.handleRemoveDictionaryImage()

            $modal.initDictionaryManagement()
            $modal.initPackingFugue()
            $modal.initTaxonGalleryManagement()

            $modal.initModalDynamicScroll()

            $modal.find('a.ajax-load').on('click', function(event) {
                event.preventDefault();
                $modal.dimmer('show');
                $.ajax({
                    url: $(this).attr('href'),
                    method: 'GET',
                    async: false,
                    success: function(content) {
                        $modal.html(content);
                        afterAjaxLoaded($modal)
                    },
                    error: function(response) {

                    }
                });
            })

            $modal.find('form.ajax-bulk-delete').on('submit', function(event) {
                event.preventDefault();
                $modal.dimmer('show');

                const formData = new FormData(event.target);

                $.ajax({
                    url: $(this).attr('action'),
                    method: $(this).attr('method'),
                    data: formData,
                    async: false,
                    processData: false,
                    contentType: false,
                    success: function(content) {
                        $modal.html(content);
                        afterAjaxLoaded($modal)
                    },
                });
            })
        }

        const $element = $(the.element);

        $element.on('click', function(event) {
            if (typeof $element.data('modal-active-tab') !== 'undefined') {
                the.lastTab = $element.data('modal-active-tab');
            }
            $modal.html('');
            $modal.dimmer('show');
            const requestedSizeClass = $element.data('modal-size');
            if (requestedSizeClass) {
              $modal.addClass(requestedSizeClass)
            }
            event.preventDefault();
            $.ajax({
                url: $element.data('modal-url'),
                method: 'GET',
                success: function(content) {
                    $modal.html(content);
                    afterAjaxLoaded($modal)
                    $modal.dimmer('hide');
                    $modal.modal('show');
                },
                error: function (content) {
                    toastr.error('Coś poszło nie tak');
                }
            });
        })
    }

    const _init = function() {
        the.uid = KUtil.getUniqueId('form-modal');
        the.element = element;

        _handlers();
        KUtil.data(the.element).set('form-modal', the);
    }

    const _construct = function() {
        if (true === KUtil.data(element).has('form-modal')) {
            the = KUtil.data(element).get('form-modal');
        } else {
            _init();
        }
    }

    _construct()
}

FormModal.createInstances = function (selector) {
    const body = document.getElementsByTagName("BODY")[0];
    const elements = body.querySelectorAll(selector);

    if ( elements && elements.length > 0 ) {
        for (let i = 0, len = elements.length; i < len; i++) {
            new FormModal(elements[i]);
        }
    }
}

FormModal.init = function () {
    FormModal.createInstances('[data-modal]');
}


if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', FormModal.init);
} else {
    FormModal.init();
}
